module.exports = __webpack_public_path__ + "img/RASP2.1eed901f.png";